module.exports = __webpack_public_path__ + "static/img/shanchu2.888b75d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/shanchu2.png
// module id = G+bN
// module chunks = 24